import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import API_BASE_URL from '../api';

const DateActivitiesInfo = () => {
  const [dateActivitiesInfo, setDateActivitiesInfo] = useState({
    activitiesDo: [],
    activitiesNotDo: [],
    flexibleOnThis: 50, // Default slider position (neutral)
  });

  const [questions, setQuestions] = useState({
    activitiesDo: 'Loading...',
    activitiesNotDo: 'Loading...',
    flexibleOnThis: 'Loading...',
  });

  const [message, setMessage] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const getAuthToken = () => localStorage.getItem('stack_access_token');
  const navigate = useNavigate();

  const availableDateActivities = [
    'Dinner at a restaurant',
    'Going to a movie',
    'Outdoor adventure',
    'Cooking together',
    'Going to a concert',
    'Visiting a museum',
    'Taking a walk in the park',
    'Traveling together',
    'Game night',
    'Volunteering together',
    'Trying a new hobby',
    'Going to the gym',
    'Shopping',
    'Attending a sports event',
    'Having a coffee date',
  ];

  useEffect(() => {
    const token = getAuthToken();
    console.log('Fetching Date Activities Info...');
    fetch(`${API_BASE_URL}/api/date-activities`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        console.log('Response status:', response.status);
        if (response.status === 404) {
          setIsNewUser(true);
          setMessage('No date activities info found. Please set your info.');
          console.log('No data found for user');
          return;
        }
        if (!response.ok) {
          throw new Error('Failed to fetch date activities info');
        }
        return response.json();
      })
      .then((data) => {
        console.log('Received Date Activities Data:', data);

        if (data) {
          const activitiesData = data.reduce((acc, item) => {
            console.log('Parsing item:', item);

            if (
              item.question_text ===
              'What are some activities that you would do on a date?'
            ) {
              acc.activitiesDo = item.answer_text
                ? item.answer_text.split(', ')
                : [];
              acc.activitiesDoQuestion = item.question_text;
            }
            if (
              item.question_text ===
              'What are some activities that you would not do on a date?'
            ) {
              acc.activitiesNotDo = item.answer_text
                ? item.answer_text.split(', ')
                : [];
              acc.activitiesNotDoQuestion = item.question_text;
            }
            if (item.question_text === 'Are you flexible on this?') {
              acc.flexibleOnThis = item.answer_text
                ? parseInt(item.answer_text, 10)
                : 50; // Default to 50 if null
              acc.flexibleOnThisQuestion = item.question_text;
            }

            return acc;
          }, {});

          console.log('Parsed Date Activities Data:', activitiesData);

          // Update both state variables: dateActivitiesInfo and questions
          setDateActivitiesInfo({
            activitiesDo: activitiesData.activitiesDo || [],
            activitiesNotDo: activitiesData.activitiesNotDo || [],
            flexibleOnThis: activitiesData.flexibleOnThis || 50,
          });

          setQuestions({
            activitiesDo: activitiesData.activitiesDoQuestion || 'Loading...',
            activitiesNotDo:
              activitiesData.activitiesNotDoQuestion || 'Loading...',
            flexibleOnThis:
              activitiesData.flexibleOnThisQuestion || 'Loading...',
          });

          console.log('Updated Questions State:', {
            activitiesDo: activitiesData.activitiesDoQuestion,
            activitiesNotDo: activitiesData.activitiesNotDoQuestion,
            flexibleOnThis: activitiesData.flexibleOnThisQuestion,
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching date activities info:', error);
        setMessage('Error fetching date activities info.');
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getAuthToken();

    const payload = {
      activitiesDo: dateActivitiesInfo.activitiesDo,
      activitiesNotDo: dateActivitiesInfo.activitiesNotDo,
      flexibleOnThis: dateActivitiesInfo.flexibleOnThis,
    };

    const method = isNewUser ? 'POST' : 'PUT';

    try {
      const response = await fetch(`${API_BASE_URL}/api/date-activities`, {
        method: method,
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to update date activities info');
      }

      setMessage('Date Activities info updated successfully.');
      setTimeout(() => navigate('/other-questions'), 2000);
      setIsNewUser(false);
    } catch (error) {
      console.error('Error setting date activities info:', error);
      setMessage('Failed to update date activities info.');
    }
  };

  const handleSelectionChange = (e, key) => {
    const values = Array.from(
      e.target.selectedOptions,
      (option) => option.value,
    );
    setDateActivitiesInfo((prevState) => ({
      ...prevState,
      [key]: values,
    }));
  };

  const handleSliderChange = (e) => {
    setDateActivitiesInfo((prevState) => ({
      ...prevState,
      flexibleOnThis: parseInt(e.target.value, 10),
    }));
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 flex justify-center items-center">
        <div
          className="w-full max-w-md p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1 className="text-4xl font-bold text-white text-center mb-6">
            Date Activities
          </h1>

          {message && (
            <p className="text-sm text-green-200 text-center mb-4">{message}</p>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Multi-select Activities To Do */}
            <div className="text-white">
              <label className="block text-sm font-medium mb-2">
                {questions.activitiesDo}
              </label>
              <select
                multiple
                value={dateActivitiesInfo.activitiesDo}
                onChange={(e) => handleSelectionChange(e, 'activitiesDo')}
                className="block w-full mt-1 px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
              >
                {availableDateActivities.map((activity) => (
                  <option key={activity} value={activity}>
                    {activity}
                  </option>
                ))}
              </select>
            </div>

            {/* Multi-select Activities Not To Do */}
            <div className="text-white">
              <label className="block text-sm font-medium mb-2">
                {questions.activitiesNotDo}
              </label>
              <select
                multiple
                value={dateActivitiesInfo.activitiesNotDo}
                onChange={(e) => handleSelectionChange(e, 'activitiesNotDo')}
                className="block w-full mt-1 px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
              >
                {availableDateActivities.map((activity) => (
                  <option key={activity} value={activity}>
                    {activity}
                  </option>
                ))}
              </select>
            </div>

            {/* Slider for Flexibility */}
            <div className="text-white">
              <label className="block text-sm font-medium mb-2">
                {questions.flexibleOnThis}
              </label>
              <input
                type="range"
                min="0"
                max="100"
                step="50"
                value={dateActivitiesInfo.flexibleOnThis}
                onChange={handleSliderChange}
                className="w-full slider"
              />
              <div className="flex justify-between text-xs mt-1">
                <span>No, I have strict preferences.</span>
                <span>Yes, I'm open to different activities.</span>
              </div>
            </div>

            {/* Navigation Buttons */}
            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Next
            </button>

            <button
              type="button"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mt-2"
              onClick={() => navigate('/interests-hobbies')}
            >
              Previous
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DateActivitiesInfo;
